import { formatNumeroCompraComAno } from './formatters';
/**
 * DISPUTAR: AS REGRAS DA ESCRITA (decisões do Heitor, 12/10/2026: D2, D3, D4, D6; padrão P2 e P4 da medição de
 * Licitações). Funções puras; a tela usa e os testes cobram dos dois lados.
 */

const brl = (n: number) => n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 4 });

/** O robô só lança de verdade com autoBid ligado e dryRun explicitamente false (dispute.service.ts:1660-1664). */
export const ehLanceReal = (bidConfig: any) => bidConfig?.autoBid === true && bidConfig?.dryRun === false;
export const sessaoViva = (status: string | null | undefined) => status === 'ativo' || status === 'aguardando';

/** D3: iniciar em REAL pergunta, dizendo o portal, os itens e a soma dos pisos. */
export function confirmacaoDeIniciarReal(sessao: any, portal: string) {
  const comPiso = (sessao?.itemLimits || []).filter((l: any) => Number(l?.limitValue) > 0);
  const soma = comPiso.reduce((t: number, l: any) => t + Number(l.limitValue), 0);
  return {
    title: 'Iniciar a disputa em LANCE REAL?',
    message: `${portal}: ${comPiso.length} ${comPiso.length === 1 ? 'item' : 'itens'} com piso; soma dos pisos ${brl(soma)}.`,
    consequence: 'O robô começa a lançar no portal assim que a sessão abrir. Lance enviado não volta atrás.',
    confirmLabel: 'Iniciar em lance real',
    danger: true,
  };
}

/** D3: parar com a disputa viva pergunta (é a direção segura, mas entrega a posição). */
export function confirmacaoDeParar() {
  return {
    title: 'Parar o robô com a disputa em andamento?',
    consequence: 'O robô deixa de cobrir os lances; a sua posição atual fica no portal como está.',
    confirmLabel: 'Parar o robô',
    // Vermelho de perigo (pedido do Heitor, 15/10/2026): o robô deixa de cobrir os lances. Sem o selo "irreversível":
    // a disputa parada pode ser iniciada de novo.
    danger: true,
    irreversivel: false,
  };
}

/** P2: o confirm do piso mostra antes → depois, item a item. */
export function pisosQueMudaram(antes: any[], depois: any[]): Array<{ item: number; antes: number; depois: number }> {
  const out: Array<{ item: number; antes: number; depois: number }> = [];
  (depois || []).forEach((d: any, i: number) => {
    const a = (antes || []).find((x: any) => x?.itemNumber === d?.itemNumber) ?? (antes || [])[i];
    if (Number(a?.limitValue) !== Number(d?.limitValue)) out.push({ item: Number(d?.itemNumber), antes: Number(a?.limitValue) || 0, depois: Number(d?.limitValue) || 0 });
  });
  return out;
}
export function confirmacaoDosPisos(mudancas: Array<{ item: number; antes: number; depois: number }>) {
  return {
    title: 'Alterar o VALOR LIMITE (piso) com a disputa EM CURSO?',
    message: mudancas.map((m) => `Item ${m.item}: ${brl(m.antes)} → ${brl(m.depois)}`).join('\n'),
    consequence: 'Muda IMEDIATAMENTE até onde o robô pode baixar o lance. Piso menor = o robô passa a poder lançar mais baixo.',
    danger: true,
    confirmLabel: 'Alterar piso',
  };
}

/** D4: mandar para disputa nomeia a proposta e o portal. */
export function confirmacaoDeMandarParaDisputa(proposta: any, portal: string) {
  const it = proposta?.item || {};
  // Pelo helper, como todo número de compra (o array com join escapava da varredura numeroCompraSoPeloHelper).
  const numero = it.numeroCompra ? formatNumeroCompraComAno(it.numeroCompra, it.anoCompra) : '';
  return {
    title: 'Mandar esta proposta para a disputa?',
    message: `Proposta #${proposta?.id}${numero ? ` · licitação ${numero}` : ''}${it.orgaoNome ? ` · ${it.orgaoNome}` : ''} · ${portal}.`,
    consequence: 'Cria a sessão de disputa em simulação, com o piso = preço da proposta. Nada é lançado até você configurar e iniciar.',
    confirmLabel: 'Mandar para a disputa',
  };
}

/** D6: o lance fechado pergunta item → valor; na falha, diz o que saiu e o que não saiu. */
export function confirmacaoDoLanceFechado(lances: Array<{ itemNumber: number; valor: number }>) {
  return {
    title: `Enviar ${lances.length} lance${lances.length === 1 ? '' : 's'} fechado${lances.length === 1 ? '' : 's'}?`,
    message: lances.map((l) => `Item ${l.itemNumber}: ${brl(l.valor)}`).join('\n'),
    consequence: 'Lance fechado é um só por item e não volta atrás.',
    confirmLabel: 'Enviar lances',
    danger: true,
  };
}
export function fraseDoLanceFechadoQueFalhou(enviados: number[], falhou: number, motivo: string, naoEnviados: number[]): string {
  const saiu = enviados.length ? `Enviados: ${enviados.map((n) => `item ${n}`).join(', ')}.` : 'Nenhum lance saiu.';
  const resto = naoEnviados.length ? ` Não enviados: ${naoEnviados.map((n) => `item ${n}`).join(', ')}.` : '';
  return `${saiu} Falhou no item ${falhou} (${motivo}).${resto} Não reenvie os enviados.`;
}
